import { OnlineSales } from 'gw-edge-client';
import { selector } from 'recoil';
import type { PaymentInformationDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/payment/';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

const RETRY_TIMEOUT = 3000;
const MAX_RETRIES = 10;

const wait = async (duration: number): Promise<void> => {
    await new Promise((resolve) => setTimeout(resolve, duration));
};

export const paymentInformationSelector = selector<PaymentInformationDTO>({
    key: 'paymentInformationSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        if (!jobNumber) {
            throw new Error('Invalid jobId');
        }
        if (!sessionId) {
            throw new Error('Invalid sessionId');
        }
        let response: PaymentInformationDTO | null = null;
        let retries = 0;

        while (!response && retries < MAX_RETRIES) {
            try {
                response = await OnlineSales.getPaymentInformation(jobNumber, sessionId);
                if (response) {
                    return response;
                }
            } catch (error) {
                retries += 1;
                if (retries === MAX_RETRIES) {
                    throw new Error('Exceeded max retries for getPaymentInformation.');
                }
                await wait(RETRY_TIMEOUT);
            }
        }

        return response as PaymentInformationDTO;
    }
});
